var map = {
	"./img-01-cookstown.jpg": 878,
	"./img-01-divyae.jpg": 371,
	"./img-02-galdur.jpg": 879,
	"./img-03-jinx.jpg": 880,
	"./img-04-kessem.jpg": 881,
	"./img-05-khomsan.jpg": 882,
	"./img-06-magic.jpg": 883,
	"./img-07-ramil.jpg": 884,
	"./img-08-sahar.jpg": 885,
	"./img-09-saksan.jpg": 886,
	"./img-10-sihir.jpg": 887,
	"./img-11-tenho.jpg": 888,
	"./img-12-thelxion.jpg": 889,
	"./img-13-aspen.jpg": 890,
	"./img-14-cedar.jpg": 891,
	"./img-15-corvus.jpg": 892,
	"./img-16-coven.jpg": 893,
	"./img-17-kiano.jpg": 894,
	"./img-18-linden.jpg": 895,
	"./img-19-rowan.jpg": 896,
	"./img-20-rune.jpg": 897,
	"./img-21-sage.jpg": 898,
	"./img-22-salem.jpg": 899,
	"./img-23-bruxo.jpg": 900,
	"./img-24-burvis.jpg": 901,
	"./img-25-cyfrin.jpg": 902,
	"./img-26-dewin.jpg": 903,
	"./img-27-guiden.jpg": 904,
	"./img-28-mage.jpg": 905,
	"./img-29-mago.jpg": 906,
	"./img-30-maldue.jpg": 907,
	"./img-31-sahir.jpg": 908,
	"./img-32-sorgin.jpg": 909,
	"./img-33-taikuri.jpg": 910,
	"./img-34-tovenaar.jpg": 911,
	"./img-35-vanir.jpg": 912,
	"./img-36-velho.jpg": 913,
	"./img-37-aelfdene.jpg": 914,
	"./img-38-alberich.jpg": 915,
	"./img-39-alwin.jpg": 916,
	"./img-40-arad.jpg": 917,
	"./img-41-aubury.jpg": 918,
	"./img-42-bari.jpg": 919,
	"./img-43-bayard.jpg": 920,
	"./img-44-cadmus.jpg": 921,
	"./img-45-drake.jpg": 922,
	"./img-46-fenris.jpg": 923,
	"./img-47-griffin.jpg": 924,
	"./img-48-ilasiaq.jpg": 925,
	"./img-49-phoenix.jpg": 926,
	"./img-50-sphinx.jpg": 927,
	"./v1/img-01-cookstown.jpg": 928,
	"./v1/img-01-divyae.jpg": 929,
	"./v1/img-02-galdur.jpg": 930,
	"./v1/img-03-jinx.jpg": 931,
	"./v1/img-04-kessem.jpg": 932,
	"./v1/img-05-khomsan.jpg": 933,
	"./v1/img-06-magic.jpg": 934,
	"./v1/img-07-ramil.jpg": 935,
	"./v1/img-08-sahar.jpg": 936,
	"./v1/img-09-saksan.jpg": 937,
	"./v1/img-10-sihir.jpg": 938,
	"./v1/img-11-tenho.jpg": 939,
	"./v1/img-12-thelxion.jpg": 940,
	"./v1/img-13-aspen.jpg": 941,
	"./v1/img-14-cedar.jpg": 942,
	"./v1/img-15-corvus.jpg": 943,
	"./v1/img-16-coven.jpg": 944,
	"./v1/img-17-kiano.jpg": 945,
	"./v1/img-18-linden.jpg": 946,
	"./v1/img-19-rowan.jpg": 947,
	"./v1/img-20-rune.jpg": 948,
	"./v1/img-21-sage.jpg": 949,
	"./v1/img-22-salem.jpg": 950,
	"./v1/img-23-bruxo.jpg": 951,
	"./v1/img-24-burvis.jpg": 952,
	"./v1/img-25-cyfrin.jpg": 953,
	"./v1/img-26-dewin.jpg": 954,
	"./v1/img-27-guiden.jpg": 955,
	"./v1/img-28-mage.jpg": 956,
	"./v1/img-29-mago.jpg": 957,
	"./v1/img-30-maldue.jpg": 958,
	"./v1/img-31-sahir.jpg": 959,
	"./v1/img-32-sorgin.jpg": 960,
	"./v1/img-33-taikuri.jpg": 961,
	"./v1/img-34-tovenaar.jpg": 962,
	"./v1/img-35-vanir.jpg": 963,
	"./v1/img-36-velho.jpg": 964,
	"./v1/img-37-aelfdene.jpg": 965,
	"./v1/img-38-alberich.jpg": 966,
	"./v1/img-39-alwin.jpg": 967,
	"./v1/img-40-arad.jpg": 968,
	"./v1/img-41-aubury.jpg": 969,
	"./v1/img-42-bari.jpg": 970,
	"./v1/img-43-bayard.jpg": 971,
	"./v1/img-44-cadmus.jpg": 972,
	"./v1/img-45-drake.jpg": 973,
	"./v1/img-46-fenris.jpg": 974,
	"./v1/img-47-griffin.jpg": 975,
	"./v1/img-48-ilasiaq.jpg": 976,
	"./v1/img-49-phoenix.jpg": 977,
	"./v1/img-50-sphinx.jpg": 978,
	"./v2/img-01-cookstown.jpg": 979,
	"./v2/img-01-divyae.jpg": 980,
	"./v2/img-02-galdur.jpg": 981,
	"./v2/img-03-divyae.jpg": 982,
	"./v2/img-03-jinx.jpg": 983,
	"./v2/img-04-kessem.jpg": 984,
	"./v2/img-05-khomsan.jpg": 985,
	"./v2/img-06-magic.jpg": 986,
	"./v2/img-07-ramil.jpg": 987,
	"./v2/img-08-sahar.jpg": 988,
	"./v2/img-08-will.jpg": 989,
	"./v2/img-09-saksan.jpg": 990,
	"./v2/img-10-sihir.jpg": 991,
	"./v2/img-11-tenho.jpg": 992,
	"./v2/img-12-thelxion.jpg": 993,
	"./v2/img-13-aspen.jpg": 994,
	"./v2/img-14-cedar.jpg": 995,
	"./v2/img-15-corvus.jpg": 996,
	"./v2/img-16-coven.jpg": 997,
	"./v2/img-17-kiano.jpg": 998,
	"./v2/img-18-linden.jpg": 999,
	"./v2/img-19-rowan.jpg": 1000,
	"./v2/img-20-rune.jpg": 1001,
	"./v2/img-21-sage.jpg": 1002,
	"./v2/img-22-salem.jpg": 1003,
	"./v2/img-23-bruxo.jpg": 1004,
	"./v2/img-24-burvis.jpg": 1005,
	"./v2/img-25-cyfrin.jpg": 1006,
	"./v2/img-26-dewin.jpg": 1007,
	"./v2/img-27-guiden.jpg": 1008,
	"./v2/img-28-mage.jpg": 1009,
	"./v2/img-29-mago.jpg": 1010,
	"./v2/img-30-maldue.jpg": 1011,
	"./v2/img-31-sahir.jpg": 1012,
	"./v2/img-32-sorgin.jpg": 1013,
	"./v2/img-33-taikuri.jpg": 1014,
	"./v2/img-34-tovenaar.jpg": 1015,
	"./v2/img-35-vanir.jpg": 1016,
	"./v2/img-36-velho.jpg": 1017,
	"./v2/img-37-aelfdene.jpg": 1018,
	"./v2/img-38-alberich.jpg": 1019,
	"./v2/img-39-alwin.jpg": 1020,
	"./v2/img-40-arad.jpg": 1021,
	"./v2/img-41-aubury.jpg": 1022,
	"./v2/img-42-bari.jpg": 1023,
	"./v2/img-43-bayard.jpg": 1024,
	"./v2/img-44-cadmus.jpg": 1025,
	"./v2/img-45-drake.jpg": 1026,
	"./v2/img-46-fenris.jpg": 1027,
	"./v2/img-47-griffin.jpg": 1028,
	"./v2/img-48-ilasiaq.jpg": 1029,
	"./v2/img-49-phoenix.jpg": 1030,
	"./v2/img-50-sphinx.jpg": 1031
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 372;